<script lang="ts">
    import Occasion from "../application/models/Occasion.ts";
    import Manager from "../application/models/Manager.ts";
    import {Icon, Modal} from 'svelma';
    import CardModal from "./modals/CardModal.svelte";
    import InfoHoverButton from "./InfoHoverButton.svelte";
    import {createEventDispatcher} from "svelte";

    export let cardData: Occasion;
    export let manager: Manager;

    let calcTime = manager.dateManager.calculateTimeFromBlockNumber;

    const dispatch = createEventDispatcher();

    function modalOpen(event){
        dispatch('modalOpen',{
            type: 'card',
            data: cardData
        });
    }
</script>

<div class="card mb-5">
    <div class="columns has-background-primary has-text-white has-text-weight-bold is-gapless">
        <div class="column has-text-centered">
            {calcTime(cardData.startBlock)}
        </div>
    </div>
    <div class="columns is-gapless m-0">
        <div class="column is-size-7 has-text-centered">
            {calcTime(cardData.startBlock)}-{calcTime(cardData.endBlock)}
        </div>
        <div class="column has-text-primary-dark has-text-weight-bold has-text-centered">
            {cardData.classroom}
        </div>
    </div>
    {#if cardData.course.subject !== null && cardData.course.subject !== undefined}
        <div class="columns is-gapless has-text-centered has-text-info-dark">
            <div class="column is-size-6 is-gapless m-0">{cardData.course.subject.name}</div>
        </div>
        <div class="columns is-gapless">
            <div class="column is-size-7 has-text-centered">
                {cardData.course.subject.code}
            </div>
            <div class="column has-text-centered has-text-primary-dark">
                <InfoHoverButton toggleFunction={modalOpen}/>
            </div>
        </div>
    {/if}
</div>